(() => {
  class SubscriptionBox {
    static BOTTLE_CLASS = 'subscription-box__bottle';
    static BOTTLE_IMAGE_HEIGHT = 390;
    static BOTTLE_IMAGE_WIDTH = 390;
    static BOTTLE_PLACEHOLDER_IMAGE = `https://cdn.shopify.com/s/files/1/0094/6788/7667/files/bottle-outline.png?width=${SubscriptionBox.BOTTLE_IMAGE_WIDTH}&height=${SubscriptionBox.BOTTLE_IMAGE_HEIGHT}`;
    static BOTTLES_PILLS_CLASS = 'subscription-box__bottles-pills';
    static BOTTLES_WRAPPER_CLASS = 'subscription-box__bottles-wrapper';
    static FREQUENCY_PILLS_CLASS = 'subscription-box__frequency-pills';
    static HEADING_CLASS = 'subscription-box__heading';
    static HEADING_WRAPPER_CLASS = 'subscription-box__heading-wrapper';
    static PILL_CLASS = 'subscription-box__pill';
    static PILLS_WRAPPER = 'subscription-box__pills-wrapper';
    static STEPS = { 1: 'Choose your quantity', 2: 'Choose your delivery frequency', 3: 'Choose your flavors below' }

    addToCartButton;
    bottleImages = { placeholder: SubscriptionBox.BOTTLE_PLACEHOLDER_IMAGE };
    bottlesPills;
    bottlesSelect;
    bottlesWrapper;
    boxBuilder;
    frequencyPills;
    frequencySelect;
    newElementsWrapper = document.createElement('div');
    stickyForm;

    constructor(stickyForm) {
      if (!stickyForm) {
        return;
      }

      this.stickyForm = stickyForm;
      this.bottlesSelect = this.stickyForm.querySelector('#product-variant-list');
      this.frequencySelect = this.stickyForm.querySelector('#selling-plan-list');

      if (!this.bottlesSelect || !this.frequencySelect) {
        console.error('Bottles or Frequency select elements not found!'); // Better error handling
        return;
      }

      this.addToCartButton = this.stickyForm.querySelector('.rb-form .rb-btn');

      if (!this.addToCartButton) {
        return;
      }

      this.boxBuilder = document.querySelector('.rb-box-builder');

      if (!this.boxBuilder) {
        return;
      }

      this.preloadImages();

      this.bottlesPills = this.createVariantsPills(
        this.bottlesSelect,
        SubscriptionBox.BOTTLES_PILLS_CLASS,
        ['mb-4', 'md:mb-10']
      );

      this.frequencyPills = this.createVariantsPills(
        this.frequencySelect,
        SubscriptionBox.FREQUENCY_PILLS_CLASS,
        ['mb-4', 'md:mb-0']
      );

      this.createBottlesWrapper();

      this.updateBottlesWrapper();

      this.createHeading('1', SubscriptionBox.STEPS[1], this.bottlesPills);

      this.createHeading('2', SubscriptionBox.STEPS[2], this.frequencyPills);

      this.createHeading('3', SubscriptionBox.STEPS[3], this.bottlesWrapper);

      this.insertNewElementsWrapper();

      this.addStaticEventListeners();

      this.cleanClasses();
    }

    addDynamicEventListeners() {
      this.boxBuilder.querySelectorAll('button.rb-btn-qty').forEach((item) => {
        item.addEventListener('click', this.updateSelectionImages.bind(this));
      });
    }

    addStaticEventListeners() {
      this.bottlesSelect.addEventListener('change', this.updateBottlesWrapper.bind(this));

      this.stickyForm.querySelectorAll(`.${SubscriptionBox.PILL_CLASS}`).forEach((item) => {
        item.addEventListener('click', this.updateSelectOnPillClick.bind(this));
        item.addEventListener('click', this.updatePillsState.bind(this));
      });
    }

    cleanBottlesWrapper() {
      while (this.bottlesWrapper.firstChild) {
        this.bottlesWrapper.removeChild(this.bottlesWrapper.firstChild);
      }
    }

    cleanClasses() {
      this.stickyForm.querySelector('form').classList.remove('titems-end-ns');
    }

    createBottlesWrapper() {
      this.bottlesWrapper = document.createElement('div');
      this.bottlesWrapper.classList.add(SubscriptionBox.BOTTLES_WRAPPER_CLASS);
      this.addToCartButton.parentElement.insertBefore(this.bottlesWrapper, this.addToCartButton);
    }

    createHeading(step, headingTextContent, insertBefore) {
      const headingWrapper = document.createElement('div');
      headingWrapper.classList.add(SubscriptionBox.HEADING_WRAPPER_CLASS, 'mb-4');

      const heading = document.createElement('p');
      heading.classList.add(SubscriptionBox.HEADING_CLASS);
      heading.dataset.step = step;
      heading.textContent = headingTextContent;

      headingWrapper.appendChild(heading);

      insertBefore.parentElement.insertBefore(headingWrapper, insertBefore);
    }

    createVariantsPills(select, selector, extraClasses = []) {
      const pillsWrapper = document.createElement('div');
      pillsWrapper.classList.add(SubscriptionBox.PILLS_WRAPPER, selector);

      pillsWrapper.classList.add(...extraClasses);

      select.options.forEach((option) => {
        const pill = document.createElement('button');
        pill.type = 'button';

        pill.classList.add(SubscriptionBox.PILL_CLASS);

        if (option.selected) {
          pill.classList.add(`${SubscriptionBox.PILL_CLASS}--selected`);
        }

        pill.dataset.selectId = select.id;
        pill.dataset.optionValue = option.value;

        if (option.dataset.sellingPlanId) {
          pill.dataset.sellingPlanId = option.dataset.sellingPlanId;
        }

        pill.textContent = option.textContent.replace('Delivery', '').trim();

        switch (pill.textContent.toLowerCase()) {
          case '4 bottles':
            pill.dataset.info = 'Free Shipping';
            break;
          case 'every 2 months':
            pill.dataset.info = 'Most Popular';
            break;
        }

        if (pill.dataset.info) {
          pillsWrapper.classList.add(`${SubscriptionBox.PILLS_WRAPPER}--info`);
          pill.classList.add(`${SubscriptionBox.PILL_CLASS}--info`);
        }

        pillsWrapper.appendChild(pill);
      });

      this.newElementsWrapper.appendChild(pillsWrapper);

      return pillsWrapper;
    }

    insertNewElementsWrapper() {
      const addToCartButtonWrapper = this.addToCartButton.parentElement;

      addToCartButtonWrapper.parentElement.insertBefore(this.newElementsWrapper, addToCartButtonWrapper);
    }

    preloadImages() {
      let preloader = document.createElement('img');

      let image;
      this.boxBuilder.querySelectorAll('.rb-item').forEach((item) => {
        image = item.querySelector('.rb-img:not(.rb-hover-img) img');

        if (!image || !image.src) {
          return;
        }

        this.bottleImages[item.dataset.rbItemId] = this.updateImageURLSize(image.src);

        preloader.src = this.bottleImages[item.dataset.rbItemId];
      });
    }

    updateBottlesWrapper() {
      this.cleanBottlesWrapper();

      const bottlesCount = parseInt(this.bottlesSelect.selectedOptions[0]?.value) || 0;

      let bottle;
      for (let i = 0; i < bottlesCount; i += 1) {
        bottle = document.createElement('div');
        bottle.classList.add(SubscriptionBox.BOTTLE_CLASS);
        this.bottlesWrapper.append(bottle);
      }

      this.updateSelectionImages();

      setTimeout(() => { this.addDynamicEventListeners() }, 10);
    }

    updateImageURLSize(url) {
      let cleanUrl = url.replace(/_[0-9]+x\./, '.').replace(/\?v=[0-9]+/, '');

      return `${cleanUrl}?width=${SubscriptionBox.BOTTLE_IMAGE_WIDTH}&height=${SubscriptionBox.BOTTLE_IMAGE_HEIGHT}`;
    }

    updatePillsState(evt) {
      const activeButton = evt.target;

      activeButton.closest(`.${SubscriptionBox.PILLS_WRAPPER}`).querySelectorAll(`.${SubscriptionBox.PILL_CLASS}`).forEach((item) => {
        item.classList.toggle(`${SubscriptionBox.PILL_CLASS}--selected`, item === activeButton);
      });
    }

    updateSelectionImages() {
      const images = [];

      let image;
      let quantity;
      this.boxBuilder.querySelectorAll('.rb-item--added').forEach((item) => {
        image = this.bottleImages[item.dataset.rbItemId] || null;
        quantity = item.querySelector('.rb-qty-wrapper input')?.value || 0;

        if (!image || !quantity) {
          return;
        }

        for (let i = 0; i < quantity; i += 1) {
          images.push(image);
        }
      });

      this.bottlesWrapper.childNodes.forEach((item, i) => {
        if (images[i]) {
          item.style.setProperty('--bottle-image', `url(${images[i]})`);
        } else {
          item.style.setProperty('--bottle-image', `url(${SubscriptionBox.BOTTLE_PLACEHOLDER_IMAGE})`);
        }
      });
    }

    updateSelectOnPillClick(evt) {
      const button = evt.target;
      const select = this.stickyForm.querySelector(`#${button.dataset.selectId}`);
      const optionValue = button.dataset.optionValue;

      if (!button.dataset.sellingPlanId) {
        select.value = optionValue;
      } else {
        for (let i = 0; i < select.options.length; i += 1) {
          if (select.options[i].dataset.sellingPlanId === button.dataset.sellingPlanId) {
            select.selectedIndex = i;
            break;
          }
        }
      }

      select.dispatchEvent(new Event('change'));
    }
  }

  function waitForElement(selector, targetSelector) {
    const target = document.querySelector(targetSelector);

    if (!target) {  // Handle the case where the target isn't found
      console.error(`Target element "${targetSelector}" not found!`);
      return; // Very important: stop here if the target is missing
    }

    const observer = new MutationObserver((mutations) => {
      for (let i = 0; i < mutations.length; i += 1) {
        const stickyForm = target.querySelector(selector);

        if (stickyForm) {
          observer.disconnect();
          new SubscriptionBox(stickyForm);
          break;
        }
      }
    });

    observer.observe(target, { childList: true, subtree: true });
  }

  const stickyForm = document.querySelector('.rb-sticky-form');
  if (!stickyForm) {
    waitForElement('.rb-sticky-form', 'main#root');
  } else {
    new SubscriptionBox(stickyForm);
  }
})();
